module.exports = __webpack_public_path__ + "staticesp/media/marcas (8).11beaaa2.jpg";